import mixitup from 'mixitup';

const mixitupContainer = document.querySelector('.faq-overview-container');

if (mixitupContainer) {
    const faqOverviewItems = document.querySelector('.faq-overview-items');
    const firstCategory = faqOverviewItems.firstElementChild;

    const faqOverviewTabs = document.querySelector('.faq-overview__tabs');
    const firstTab = faqOverviewTabs.firstElementChild;

    var mixer = mixitup(mixitupContainer, {
        load: {
            filter: firstCategory,
        },
        selectors: {
            target: '.faq-tab-content',
        },
        animation: {
            easing: 'ease-in-out',
        },
        controls: {
            toggleLogic: 'or',
        },
    });

    firstTab.classList.add('mixitup-control-active');
}
